export const DEFAULT_FILTERS = {
  sort: 'price-asc',
  minPrice: 0,
  maxPrice: 5000,
  cabinType: 'any',
  minNights: 0,
};

export function getPriceBounds(results) {
  if (!results.length) return { min: 0, max: 500 };
  const prices = results.map((r) => r.price);
  return {
    min: Math.floor(Math.min(...prices)),
    max: Math.ceil(Math.max(...prices)),
  };
}

export function applyCruiseFilters(results, filters) {
  return results.filter((r) => {
    if (r.price < filters.minPrice || r.price > filters.maxPrice) return false;
    if (filters.cabinType !== 'any' && r.cabin !== filters.cabinType) return false;
    if (filters.minNights > 0 && r.nights < filters.minNights) return false;
    return true;
  });
}

export function sortResults(results, sort) {
  const list = [...results];
  if (sort === 'price-desc') return list.sort((a, b) => b.price - a.price);
  if (sort === 'nights-asc') return list.sort((a, b) => a.nights - b.nights);
  if (sort === 'nights-desc') return list.sort((a, b) => b.nights - a.nights);
  return list.sort((a, b) => a.price - b.price);
}

export function filterResults(results, filters) {
  return sortResults(applyCruiseFilters(results, filters), filters.sort);
}
